import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout active="">
      <Seo
        title="页面不存在 - 91视频网站"
        description="抱歉，您访问的页面不存在，可以返回首页继续浏览最新电影、电视剧与综艺资源。"
        keywords="91视频网站,404,页面不存在"
      />
      <div className="w-full px-4 md:px-6 xl:px-10 py-20 md:py-28 text-center">
        <p className="font-heading text-[80px] md:text-[120px] leading-none font-black text-background-200 select-none">
          404
        </p>
        <h1 className="mt-2 font-heading text-xl md:text-2xl font-bold text-foreground-950">这个页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-500 break-all">{location.pathname}</p>
        <p className="mt-1 text-sm text-foreground-500">链接可能已更改，回到首页继续找片吧。</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          <Link
            to="/"
            className="h-10 px-5 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            浏览电影频道
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}